import { BaseAPI } from "@utils/base-api";
import { AxiosResponse } from "axios";
import { Product } from "libs/api/customer/src/lib/types/products";

export type VariablePricingKey = number | "default";

export interface IVariablePricing {
  discount: number;
  unitPrice: number;
  quantity: number;
}

export type IQuantityToPrice = {
  quantityToPrice: Record<VariablePricingKey, IVariablePricing>
};

export interface IUpcomingDiscount {
  name: string;
  expiresAt: string;
}

export class LitterAPI extends BaseAPI {

  public async getPricesByProductId(productTitle: Product):Promise<AxiosResponse<IQuantityToPrice>> {
    try {
      return await this.axios.get(
        `/customer/extraPlan/getProductPrices?productTitle=${productTitle}`,
      );
    } catch (error) {
      throw new Error();
    }
  }

}
